import WildAppResource from "./WildAppResource";
import FormAppResource from "./FormAppResource";
import FormsetAppResource from "./FormsetAppResource";

export const SELLERS_DISCLOSURE = 11010;
export const ONBOARDING = 11020;
export const BUYER_AGENCY = 11030;
export const LISTING = 11040;
export const PURCHASE_CONTRACT = 11050;
export const MORTGAGE_APPLICATION = 11060;
export const OTHER = 11070;

export const ALL = {
    SELLERS_DISCLOSURE,
    ONBOARDING,
    BUYER_AGENCY,
    LISTING,
    PURCHASE_CONTRACT,
    MORTGAGE_APPLICATION,
    OTHER,
};

class LuFormCategoryAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-form-category';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/forms/categories';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            forms: FormAppResource,
            formsets: FormsetAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuFormCategoryAppResource;
